export { default } from './BlogDetailsPage';

export * from './BlogDetailsPage';
